import Dashboard from 'pages/dashboard/Dashboard';
import Instructions from 'pages/instructions/Instructions';
import InstructionsDetail from 'pages/instructions/InstructionsDetail';
import Faq from 'pages/faq/Faq';
import MyDocuments from 'pages/my-documents/MyDocuments';
import Helpdesk from 'pages/helpDesk/HelpDesk';
import HelpdeskDetail from 'pages/helpDesk/HelpDeskDetail';
import Ticket from 'pages/helpDesk/Ticket';
import House from 'pages/house/House';
import Ecv from 'pages/house/ecv/Ecv';
import EcvAdd from 'pages/house/ecv/EcvAdd';
import EcvEdit from 'pages/house/ecv/EcvEdit';
import Rfid from 'pages/house/rfid/Rfid';
import RfidAdd from 'pages/house/rfid/RfidAdd';
import RfidPair from 'pages/house/rfid/RfidPair';
import PinCode from 'pages/house/pincode/PinCode';
import TemporaryPinCode from 'pages/house/temporary-pin-code/TemporaryPinCode';
import Users from 'pages/house/users/Users';
import UserAdd from 'pages/house/users/UserAdd';
import { Route, Routes } from 'react-router-dom';

import {
  DASHBOARD_PATH,
  INSTRUCTIONS_PAGE_PATH,
  INSTRUCTIONS_DETAIL_PAGE_PATH,
  MYDOCUMENTS_PAGE_PATH,
  FAQ_PAGE_PATH,
  HELPDESK_PAGE_PATH,
  HELPDESK_DETAIL_PAGE_PATH,
  TICKET_PAGE_PATH,
  HOUSE_PAGE_PATH,
  ECV_PAGE_PATH,
  ECV_ADD_PAGE_PATH,
  ECV_EDIT_PAGE_PATH,
  RFID_PAGE_PATH,
  RFID_ADD_PAGE_PATH,
  RFID_PAIR_PAGE_PATH,
  PIN_CODE_PAGE_PATH,
  TEMPORARY_PIN_CODE_PAGE_PATH,
  USERS_PAGE_PATH,
  USER_ADD_PAGE_PATH,
  USER_PIN_CODE_PAGE_PATH,
  USER_TEMPORARY_PIN_CODE_PAGE_PATH,
  SENSOR_DETAIL_PAGE_PATH,
  SENSOR_DETAIL_EDIT_PAGE_PATH,
  AIR_CONDITIONER_PAGE_PATH,
  AIR_CONDITIONER_DETAIL_PAGE_PATH,
  TUYA_DEVICE_DETAIL_PAGE_PATH,
  DOCUMENT_DETAIL_PAGE_PATH,
  SPOT_COMPARATOR_PATH,
  ENERGY_CONSUMPTION_PATH,
  FORBIDDEN_PAGE_PATH,
  CHATBOT_PAGE_PATH,
  DOOR_BELL_PAGE_PATH,
  CALL_ORDER_PAGE_PATH,
  SET_PHONE_PAGE_PATH,
  SET_SECOND_PHONE_PAGE_PATH,
  GARAGE_PAGE_PATH,
  EV_CHARGING_STATION_PAGE_PATH,
} from 'routes/paths';
import SensorDetail from 'pages/sensors/SensorDetail';
import SensorDetailEdit from 'pages/sensors/AlertSettingsPage';
import AirConditionerLanding from 'pages/air-conditioner/AirConditionerLanding';
import AirConditionerDetail from 'pages/air-conditioner/AirConditionerDetail';
import TuyaDeviceDetail from 'pages/tuya-device/TuyaDeviceDetail';
import DocumentDetail from 'pages/my-documents/DocumentDetail';
import SpotComparator from 'pages/spot-comparator/SpotComparator';
import EnergyConsumption from 'pages/tuya-device/EnergyConsumption';
import Forbidden from 'pages/errors/Forbidden';
import ChatBot from 'pages/chatbot/ChatBot';
import DoorBell from 'pages/house/doorbell/DoorBell';
import CallOrder from 'pages/house/call-order/CallOrder';
import SetPhone from 'pages/house/call-order/SetPhone';
import SetSecondPhone from 'pages/house/call-order/SetSecondPhone';
import Garage from 'pages/garage/Garage';
import EvChargingStationDetail from 'pages/ev-charging-station/EvChargingStationDetail';

/**
 * All routes in the app must be registered here.
 */
export default function AppRoutes() {
  return (
    <Routes>
      {/* Dashboard */}
      <Route path={DASHBOARD_PATH.original} element={<Dashboard />} />
      {/* MyDocuments */}
      <Route path={MYDOCUMENTS_PAGE_PATH.original} element={<MyDocuments />} />
      <Route path={DOCUMENT_DETAIL_PAGE_PATH.original} element={<DocumentDetail />} />
      {/* Instructions */}
      <Route path={INSTRUCTIONS_PAGE_PATH.original} element={<Instructions />} />
      {/* Instructions detail*/}
      <Route path={INSTRUCTIONS_DETAIL_PAGE_PATH.original} element={<InstructionsDetail />} />
      {/* FAQ*/}
      <Route path={FAQ_PAGE_PATH.original} element={<Faq />} />
      {/* Helpdesk*/}
      <Route path={HELPDESK_PAGE_PATH.original} element={<Helpdesk />} />
      {/* Helpdesk detail*/}
      <Route path={HELPDESK_DETAIL_PAGE_PATH.original} element={<HelpdeskDetail />} />
      {/* Ticket*/}
      <Route path={TICKET_PAGE_PATH.original} element={<Ticket />} />
      {/* House*/}
      <Route path={HOUSE_PAGE_PATH.original} element={<House />} />
      {/* ECV*/}
      <Route path={ECV_PAGE_PATH.original} element={<Ecv />} />
      {/* ECV add*/}
      <Route path={ECV_ADD_PAGE_PATH.original} element={<EcvAdd />} />
      {/* ECV edit*/}
      <Route path={ECV_EDIT_PAGE_PATH.original} element={<EcvEdit />} />
      {/* RFID chips */}
      <Route path={RFID_PAGE_PATH.original} element={<Rfid />} />
      {/* RFID add */}
      <Route path={RFID_ADD_PAGE_PATH.original} element={<RfidAdd />} />
      {/* RFID pair */}
      <Route path={RFID_PAIR_PAGE_PATH.original} element={<RfidPair />} />
      {/* PIN code */}
      <Route path={PIN_CODE_PAGE_PATH.original} element={<PinCode />} />
      {/* Temporary PIN codes */}
      <Route path={TEMPORARY_PIN_CODE_PAGE_PATH.original} element={<TemporaryPinCode />} />
      {/* Users */}
      <Route path={USERS_PAGE_PATH.original} element={<Users />} />
      {/* User add */}
      <Route path={USER_ADD_PAGE_PATH.original} element={<UserAdd />} />
      {/* User PIN code */}
      <Route path={USER_PIN_CODE_PAGE_PATH.original} element={<PinCode />} />
      {/* User temporary PIN codes */}
      <Route path={USER_TEMPORARY_PIN_CODE_PAGE_PATH.original} element={<TemporaryPinCode />} />
      {/* Sensor detail */}
      <Route path={SENSOR_DETAIL_PAGE_PATH.original} element={<SensorDetail />} />
      <Route path={SENSOR_DETAIL_EDIT_PAGE_PATH.original} element={<SensorDetailEdit />} />
      {/* Air Conditioner landing (auth + device selection) */}
      <Route path={AIR_CONDITIONER_PAGE_PATH.original} element={<AirConditionerLanding />} />
      {/* Air Conditioner detail */}
      <Route path={AIR_CONDITIONER_DETAIL_PAGE_PATH.original} element={<AirConditionerDetail />} />
      {/* Tuya device detail */}
      <Route path={TUYA_DEVICE_DETAIL_PAGE_PATH.original} element={<TuyaDeviceDetail />} />
      {/* Garage */}
      <Route path={GARAGE_PAGE_PATH.original} element={<Garage />} />
      {/* EV Charging Station */}
      <Route path={EV_CHARGING_STATION_PAGE_PATH.original} element={<EvChargingStationDetail />} />
      {/* Spot Comparator */}
      <Route path={SPOT_COMPARATOR_PATH.original} element={<SpotComparator />} />
      {/* Energy Consumption */}
      <Route path={ENERGY_CONSUMPTION_PATH.original} element={<EnergyConsumption />} />
      {/* Error pages */}
      <Route path={FORBIDDEN_PAGE_PATH.original} element={<Forbidden />} />
      {/* Chatbot pages */}
      <Route path={CHATBOT_PAGE_PATH.original} element={<ChatBot />} />
      {/* Door bell */}
      <Route path={DOOR_BELL_PAGE_PATH.original} element={<DoorBell />} />
      {/* Call Order */}
      <Route path={CALL_ORDER_PAGE_PATH.original} element={<CallOrder />} />
      {/* Set Phone (primary GSM) */}
      <Route path={SET_PHONE_PAGE_PATH.original} element={<SetPhone />} />
      {/* Set Second Phone */}
      <Route path={SET_SECOND_PHONE_PAGE_PATH.original} element={<SetSecondPhone />} />
    </Routes>
  );
}
